import styled from "styled-components";
import { BubbleTooltipContainerDefaultBox } from "./bubble-tooltip-container.default.box";

export const BubbleTooltipContainerCasino777Box = styled(BubbleTooltipContainerDefaultBox)`
    color: ${({ theme }) => theme.colors.moneyColor};
    padding-block: 12px;
`;